import { useEffect, useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
    Box,
    Grid,
    FormControl,
    Button,
    CircularProgress,
    Typography
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Popup from "../../../../Base/views/Popup";
import { GetDailyWageReportAction, GetDailyWageReportNotProcessedAction } from "../../../../../../store/Finance/Reports/Action";
import { GenerateDailyWageReportHelper } from "../../../helper/Reports/GetWageReportHelper";
import ConfirmationDialog from "../../../../Base/views/ConfirmationDialog";
import { formatPayDatePeriod } from "../../../../Base/helper/baseFunctions";
import { AddMenuHeadingAction } from "../../../../../../store/Menu/Action";
import history from "../../../../../../history";
import { toast } from "react-toastify";
import { GetPayrollTileViewAction } from "../../../../../../store/Finance/PayrollManagement/Action";
import SelectableMultiSelect from "../../../../Base/views/SelectableMultiSelect";

const PSRWageNotProcessedEmp = ({selectedYear, selectedMonth, readOnly, paydate, worklocationData, handleWorkLoacation}) => {
    const dispatch = useDispatch();
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);

    const { daily_wage_report_notprocessed_data, isLoading } = useSelector(
        (state) => state?.FinanceReducer.WageReportsReducer
    );
    const [openwarningPopup, setWarningOpenPopup] = useState(false);
    const [navigateSection, setNavigateSection] = useState("");
    const [navigateId, setNavigateId] = useState("");
    const [msg, setMsg] = useState("");
    const [anchorE, setAnchorE] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isLoadingbtn, setIsLoadingbtn] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [filters, setFilters] = useState({
                ats_work_location_id: []
            });
    useEffect(() => {
        const f_month = parseInt(selectedMonth, 10).toString();
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        dispatch(GetDailyWageReportNotProcessedAction({ month: f_month, year: String(selectedYear),
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
         }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, filters]);

    const handleSelect = (rows) => {
        setSelectedRows(rows);
    };
    const handleGenerateClicked = () => {
        if (!work_hours_data) {
            setMsg("Work Hour configuration is required for payroll settings. Please configure it now.");
            setNavigateSection("General");
            setNavigateId("4");
            setWarningOpenPopup(true);
        } else {
            setAnchorE(null);
            setOpenDialog(true);
        }
    };
    const handleNavigate = (menu, value) => {
        sessionStorage.setItem("selectedMenu", menu);
        dispatch(AddMenuHeadingAction({ heading: menu }));
        history.push({
            pathname: "/settings",
            state: { click_event: value },
        });
    };
    const handleGenerate = () => {
        setIsLoadingbtn(true);
        const f_year= String(selectedYear);
        const f_month = parseInt(selectedMonth, 10).toString();
        const id = selectedRows.map(item => item.employee_fk);
        GenerateDailyWageReportHelper({
            employee_id: id?.length ? `{${id}}` : null,
            month: f_month,
            year: f_year
        }).then((res) => {
            if (res?.data?.statuscode === 200) {
                dispatch(GetDailyWageReportNotProcessedAction({ month: f_month, year: f_year }));
                dispatch(GetDailyWageReportAction({ month: f_month, year: f_year }));
                dispatch(GetPayrollTileViewAction({ year: String(selectedYear) }))
                setSelectedRows([]);
            }
            else if (res?.data?.statuscode === 500) {
                toast.error("Something went wrong")
            }
            setIsLoadingbtn(false);
        });
        setOpenDialog(false);
    };
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
    const tableTitle = (<Box>
              <Typography variant="h6" fontWeight={600}>
                Not Processed Employee
              </Typography>
              <Typography variant="body2" color="text.secondary">
                New employees not included in the current payroll cycle
              </Typography>
            </Box>)

    return (
        <Box sx={{ overflowY: "auto"}}>
            <Box sx={{ m: 1 }}>
                <Grid sx={{ display: "flex", justifyContent: "space-between" }} container columnSpacing={1} mb={1} mt={1}>
                    <FormControl>
                    </FormControl>
                    <div>
                        {(selectedRows?.length > 0) && !readOnly && (
                                <Button
                                    onClick={handleGenerateClicked}
                                    className="mpl-primary-btn"
                                    disabled={isLoadingbtn}
                                    startIcon={isLoadingbtn ? <CircularProgress size={18} color="inherit" /> : null}
                                >
                                    Generate Payroll
                                </Button>
                            )}
                    </div>
                </Grid>
            </Box>

            <Box>
                <MaterialTable
                    isLoading={isLoading}
                    columns={[
                        { title: "Employee No", field: "employee_no" ,cellStyle: {padding: "0px 0px 0px 50px"}, headerStyle: {padding: "5px 0px 5px 50px"},},
                        { title: "Employee Name", cellStyle: {padding: "0px 0px 0px 50px"}, headerStyle: {padding: "5px 0px 5px 50px"}, field: "name" },
                        { title: "Work Location", cellStyle: {padding: "0px 0px 0px 53px"}, headerStyle: {padding: "5px 0px 5px 50px"}, field: "work_location_name",
                            render: (rowData) => rowData?.work_location_name || "N/A"
                        },
                        { title: "Reason", cellStyle: {padding: "0px 0px 0px 50px"}, headerStyle: {padding: "5px 0px 5px 50px"},field: "reason" },
                    ]}
                    data={ daily_wage_report_notprocessed_data || []}
                    options={{
                        maxBodyHeight: 320,
                        minBodyHeight: 320,
                        rowStyle: { fontSize: "13px", height:"35px" },
                        headerStyle: { padding: "5px 10px 5px 13px", fontWeight: "bold" },
                        sorting: false,
                        search: true,
                        searchFieldAlignment: "right",
                        searchAutoFocus: false,
                        filtering: false,
                        paging: true,
                        pageSizeOptions: [25, 50],
                        pageSize: 25,
                        selection: !readOnly,
                        actionsColumnIndex: -1,
                        showSelectAllCheckbox: true,
                        showTextRowsSelected: true,
                        grouping: false,
                        columnsButton: false,
                        showTitle: true,
                    }}
                    onSelectionChange={handleSelect}
                    onChangePage={(page) => setCurrentPage(page)} 
                    page={currentPage} 
                    title={""}
                    components={{
                        Toolbar: (props) => (
                            <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                                <Box
                                    sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#f3edfd",
                                    padding: "0px 0px 0px 20px",
                                    flexGrow: 1,
                                    minHeight: "48px !important",
                                    }}
                                >
                                <Box>
                                    <Typography variant='h6'>
                                        {tableTitle}
                                    </Typography>
                                </Box>
                                <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                    <SelectableMultiSelect
                                        multiple
                                        label="Work Location"
                                        placeholder="Select Location"
                                        value={filters?.ats_work_location_id}
                                        loading={handleWorkLoacation}
                                        fieldLabel="work_location_name"
                                        name="ats_work_location_id"
                                        size="small"
                                        onChangeEvent={handleFilterChange}
                                        data={worklocationData}
                                        menuHeight={150} // optional
                                    />
                                </Box> 
                                </Box>
                                    <Box
                                    sx={{
                                        "& .MuiToolbar-root": {
                                        padding: "12px 16px !important",
                                        margin: "0 !important",
                                        minHeight: "48px !important",
                                        },
                                        "& .MuiFormControl-root": {
                                        margin: "0 !important",
                                        },
                                        "& .MuiInputBase-root": {
                                        marginLeft: "-20px !important",
                                        }
                                    }}
                                    >
                                        <MTableToolbar {...props} />
                                    </Box>
                                </Box>
                        ),
                    }}
                />
            </Box>

            <ConfirmationDialog
                title="Generate Payroll"
                content={`Payroll will be generated from ${formatPayDatePeriod(paydate)}. Are you sure you want to continue?`}
                anchorE={anchorE}
                openDialog={openDialog}
                closeDialog={setOpenDialog}
                OkButtonText="Yes"
                onSubmit={handleGenerate}
            />
            <Popup
                fullWidth={true}
                maxWidth="md"
                title="Warning"
                openPopup={openwarningPopup}
                setOpenPopup={setWarningOpenPopup}
            >
                <Typography sx={{ pt: 2, pb: 2, textAlign: "center" }} variant="h5">
                    ⚠️ {msg}
                </Typography>

                <Box display="flex" justifyContent="center" gap={2} sx={{ mt: 2 }}>
                    <Button
                        onClick={() => handleNavigate(navigateSection, navigateId)}
                        className="mpl-primary-btn"
                    >
                        Configure Now
                    </Button>
                </Box>
            </Popup>
            
        </Box>
    );
};

export default PSRWageNotProcessedEmp;